export default __webpack_public_path__ + "static/media/carParkingAvailable.bb12f2a5.svg";